import React from "react";
import "./FormContactarGrupal.scss";

interface ContactarGrupalListProps {
    fullName: string;
    index: number;
    setIsEliminationProcess: any;
    setIndexHelper: any;
    setAllowList: any;
    listSelectedTalents: any;
    setIsProhibited: any;
    setIsDisabledForProhibited: any;
    setProfession: any;
    professionHelper: any;
}

const FormContactarGrupal = (props: ContactarGrupalListProps ) => {
    const { 
        fullName,
        index, 
        setIsEliminationProcess,
        setIndexHelper,
        setAllowList,
        listSelectedTalents,
        setIsProhibited,
        setIsDisabledForProhibited,
        setProfession,
        professionHelper
    } = props;
    
    return (
        <div className="m-form-contactar-grupal">
            <div className="m-form-contactar-grupal__container">
                <div className="m-form-contactar-grupal__container__name">
                    <p>{fullName}</p> 
                </div>
                <div className="m-form-contactar-grupal__container__icon">
                    {listSelectedTalents.length < 2 ?
                        (
                            <span onClick={() => {
                                setIsProhibited(true);
                                setAllowList(false);
                                setIsDisabledForProhibited(true);
                            }}>
                                <i className="icon-trash-alt1"></i>
                            </span>
                        )
                        : 
                        (
                           <span onClick={() => {
                                setIsEliminationProcess(true);
                                setIndexHelper(index);
                                setAllowList(false);
                                setProfession(professionHelper);
                            }}>
                                <i className="icon-trash-alt1"></i>
                            </span>
                        )
                    }
                    
                </div>
            </div>
        </div>
    );
};
export default FormContactarGrupal;
